/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SessionStatus = {
    Draft: 'draft',
    Open: 'open',
    Closed: 'closed',
} as const;
export type SessionStatus = typeof SessionStatus[keyof typeof SessionStatus];


export function instanceOfSessionStatus(value: any): boolean {
    for (const key in SessionStatus) {
        if (Object.prototype.hasOwnProperty.call(SessionStatus, key)) {
            if (SessionStatus[key as keyof typeof SessionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SessionStatusFromJSON(json: any): SessionStatus {
    return SessionStatusFromJSONTyped(json, false);
}

export function SessionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionStatus {
    return json as SessionStatus;
}

export function SessionStatusToJSON(value?: SessionStatus | null): any {
    return value as any;
}

export function SessionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SessionStatus {
    return value as SessionStatus;
}

